import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import CONFIG from '../../config';
import NavBarEstudianteTutor from './NavBarEstudianteTutor';

const URL_EVALUACIONES = `${CONFIG.API_URL}/operarEvaluaciones.php`;

function EvaluacionesTrabajosEstudiante({ acceder, configuracion }) {
    const navigate = useNavigate();
    const llamoTutor = localStorage.getItem('kte') || null;

    const [datoEstudiante] = useState(() => {
        if (llamoTutor && llamoTutor !== 'null') {
            try {
                const [, estudianteStr] = llamoTutor.split('&');
                return JSON.parse(estudianteStr);
            } catch (e) {
                return null;
            }
        }
        return null;
    });

    const [userId] = useState(() => {
        if (datoEstudiante && datoEstudiante.estudiante_id) {
            return datoEstudiante.estudiante_id;
        }
        return parseInt(localStorage.getItem('loggedUserId'), 10) || null;
    });

    const [evaluaciones, setEvaluaciones] = useState([]);
    const [actividades, setActividades] = useState([]);
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        if (!acceder) {
            localStorage.clear();
            navigate('/');
            return;
        }
        if (userId) {
            obtenerResumen();
        }
    }, [acceder, navigate, userId]);

    const obtenerResumen = async () => {
        setCargando(true);
        try {
            const res = await axios.get(`${URL_EVALUACIONES}?modo=resumen_estudiante&id_estudiante=${userId}`);
            if (res.data && !res.data.error) {
                setEvaluaciones(res.data.evaluaciones || []);
                setActividades(res.data.actividades || []);
            } else {
                setEvaluaciones([]);
                setActividades([]);
            }
        } catch (err) {
            console.error('Error al obtener evaluaciones y trabajos del estudiante:', err);
            setEvaluaciones([]);
            setActividades([]);
        } finally {
            setCargando(false);
        }
    };

    const formatearFecha = (fechaStr) => {
        if (!fechaStr) return '-';
        const soloFecha = String(fechaStr).split(' ')[0];
        const partes = soloFecha.split('-');
        if (partes.length === 3) {
            return `${partes[2]}/${partes[1]}/${partes[0]}`;
        }
        return soloFecha;
    };

    const badgeEstadoActividad = (estado) => {
        const estLower = String(estado || '').toLowerCase().trim();
        if (estLower === 'aprobado') return 'bg-success';
        if (estLower.includes('sugerencias')) return 'bg-info text-dark';
        if (estLower === 'reentrega') return 'bg-warning text-dark';
        if (estLower === 'desaprobado') return 'bg-danger';
        return 'bg-secondary';
    };

    const evaluacionesCalificadas = evaluaciones.filter(
        (ev) => ev.calificacion !== null && ev.calificacion !== undefined && String(ev.calificacion).trim() !== ''
    );

    return (
        <div className="container-principal">
            {llamoTutor && datoEstudiante && (
                <NavBarEstudianteTutor estudiante={datoEstudiante} configuracion={configuracion} />
            )}

            <div className="card shadow border-0 p-4 mb-4">
                <h4 className="mb-1">
                    <i className="fa-solid fa-clipboard-check text-primary me-2"></i>
                    Evaluaciones y Trabajos Prácticos Calificados
                </h4>
                <p className="text-muted small mb-4">
                    Detalle de las evaluaciones (orales y escritas) y trabajos prácticos calificados al estudiante.
                </p>

                {cargando ? (
                    <div className="text-center py-4 text-muted">
                        <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                        Cargando información...
                    </div>
                ) : (
                    <>
                        {/* SECCIÓN 1: EVALUACIONES CALIFICADAS */}
                        <div className="mb-4">
                            <h5 className="border-bottom pb-2 mb-3">
                                <i className="fa-solid fa-file-signature text-success me-2"></i>
                                Evaluaciones Calificadas ({evaluacionesCalificadas.length})
                            </h5>

                            {evaluacionesCalificadas.length === 0 ? (
                                <div className="alert alert-light border small text-muted">
                                    No registran evaluaciones calificadas hasta el momento.
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-hover table-sm align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Fecha</th>
                                                <th>Espacio</th>
                                                <th>Título / Tema</th>
                                                <th>Modalidad</th>
                                                <th>Descripción</th>
                                                <th className="text-center">Calificación</th>
                                                <th>Observación Docente</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {evaluacionesCalificadas.map((ev) => {
                                                const esOral = String(ev.modalidad).toLowerCase() === 'oral';
                                                return (
                                                    <tr key={ev.id}>
                                                        <td className="text-nowrap">{formatearFecha(ev.fecha)}</td>
                                                        <td className="fw-semibold">{ev.nombre_espacio}</td>
                                                        <td className="fw-bold">{ev.titulo}</td>
                                                        <td>
                                                            <span className={`badge ${esOral ? 'bg-info text-dark' : 'bg-primary'}`}>
                                                                {esOral ? 'Oral' : 'Escrita'}
                                                            </span>
                                                        </td>
                                                        <td className="small text-muted">{ev.descripcion || '-'}</td>
                                                        <td className="text-center">
                                                            <span className="badge bg-success fs-6 px-3 py-1">
                                                                {ev.calificacion}
                                                            </span>
                                                        </td>
                                                        <td className="small text-muted">{ev.observacion || '-'}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>

                        {/* SECCIÓN 2: TRABAJOS PRÁCTICOS (ACTIVIDADES) CALIFICADOS */}
                        <div>
                            <h5 className="border-bottom pb-2 mb-3">
                                <i className="fa-solid fa-book-open-reader text-primary me-2"></i>
                                Trabajos Prácticos (Actividades) Calificados ({actividades.length})
                            </h5>

                            {actividades.length === 0 ? (
                                <div className="alert alert-light border small text-muted mb-0">
                                    No registran trabajos prácticos calificados hasta el momento.
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-hover table-sm align-middle mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Fecha Evaluación</th>
                                                <th>Espacio</th>
                                                <th>Trabajo Práctico / Actividad</th>
                                                <th>Tipo</th>
                                                <th className="text-center">Calificación / Estado</th>
                                                <th>Devolución Docente</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {actividades.map((act) => (
                                                <tr key={act.id_entrega}>
                                                    <td className="text-nowrap">
                                                        {formatearFecha(act.fecha_devolucion || act.fecha_entrega)}
                                                    </td>
                                                    <td className="fw-semibold">{act.nombre_espacio}</td>
                                                    <td>
                                                        <div className="fw-bold">{act.titulo}</div>
                                                        {act.desarrollo && (
                                                            <div className="small text-muted">{act.desarrollo}</div>
                                                        )}
                                                    </td>
                                                    <td className="text-capitalize small">{act.tipo_trabajo || '-'}</td>
                                                    <td className="text-center">
                                                        <span className={`badge ${badgeEstadoActividad(act.estado)} px-2 py-1`}>
                                                            {String(act.estado || '').toUpperCase()}
                                                        </span>
                                                    </td>
                                                    <td className="small text-muted">{act.devolucion || '-'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default EvaluacionesTrabajosEstudiante;

